import { render, staticRenderFns } from "./BookUserBar.vue?vue&type=template&id=72dc289a&"
import script from "./BookUserBar.vue?vue&type=script&lang=js&"
export * from "./BookUserBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports